<template>
    <div class="chat">
        <div class="close-btn" v-on:click="closeChat" aria-label="Luk quiz">
            <no-drag-image src="@/assets/btn-chatbot-close.png" :scale="1" />
        </div>
        <div v-if="error"><strong>Error</strong>: {{ error }}</div>
        <chat-node
                v-for="(chatNode, key) in chatNodes"

                :key="key"
                :node="chatNode"

                v-on:pickedAnswer="onPickedAnswer"
        />
    </div>
</template>

<script>
    import ChatNode from "./ChatNode";
    import NoDragImage from "@/sgi/common/NoDragImage";

    export default {
        name: "chat",
        components: {
            ChatNode,
            NoDragImage
        },
        props: {
            data: {
                type: Object
            }
        },
        data() {
            return {
                error: null,
                chatNodes: [],
            }
        },
        mounted() {
            this.openNode(this.data.startNode);
        },
        methods: {
            closeChat() {
                this.$emit('closeChat');
            },
            setError(error) {
                this.error = error;
            },
            openNode(node) {
                if (!this.data.nodes.hasOwnProperty(node)) {
                    return this.setError(`Node "${node}" not found`);
                }

                let nodeData = this.data.nodes[node];

                this.chatNodes.push(nodeData);
            },
            onPickedAnswer(answer, node) {
                if (node.exitType) {
                    // It's an exit node, don't do anything else
                    console.log('Node exit: ' + node.exitType, node);
                } else if (answer.goto) {
                    this.openNode(answer.goto);
                } else {
                    this.setError('Answer picked, but it had no goto');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .chat {
        margin: 0 auto;
        padding-top: 20px;
        position: relative;

        .close-btn {
            position: fixed;
            top: 10px;
            right: 30px;
            width: 33px;
            height: 33px;
            display: inline-block;
            cursor: pointer;
            z-index: 999999999999;
        }
    }
</style>
